var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-hyperlink-integration',{attrs:{"value":_vm.value.location,"button":_vm.button}},[_c('t-content-integration',{attrs:{"value":_vm.value.note,"button":_vm.button}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }